<template>
  <div :class="componentClasses">
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      width="25px"
      height="25px"
      viewBox="0 0 50 50"
      style="enable-background: new 0 0 50 50"
      xml:space="preserve"
      v-if="supportsSvgAnimation"
    >
      <path
        :style="{ fill: loaderColor }"
        d="M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z"
        transform="rotate(250 25 25)"
      >
        <animateTransform
          attributeType="xml"
          attributeName="transform"
          type="rotate"
          from="0 25 25"
          to="360 25 25"
          dur="0.6s"
          repeatCount="indefinite"
        />
      </path>
    </svg>
    <img v-else :src="gifLoaderImage" />
  </div>
</template>

<script>
export default {
  name: 'ax-loader',
  data() {
    return {
      componentClass: 'ax--loader',
    }
  },
  computed: {
    supportsSvgAnimation() {
      const checkFeature = document.implementation.hasFeature(
        'http://www.w3.org/TR/SVG11/feature#AnimationEventsAttribute',
        '1.0'
      )

      if (window.BrowserIsIE) {
        return false
      }

      return checkFeature
    },
    componentClasses() {
      let classList = []

      classList.push(`${this.componentClass}`)
      if (this.size) {
        classList.push(`${this.componentClass}--${this.size}`)
      }
      if (this.position) {
        classList.push(`${this.position}`)
      }

      return classList.join(' ')
    },

    gifColor() {
      if (this.loaderColor) {
        const supportedColors = ['#000', '#fff', '#999', '#CCC']
        if (supportedColors.includes(this.loaderColor)) {
          return this.loaderColor.replace('#', '')
        }

        if (this.loaderColor.toUpperCase() === 'WHITE') {
          return 'fff'
        }

        if (this.loaderColor.toUpperCase() === 'BLACK') {
          return '000'
        }

        if (this.loaderColor.toUpperCase() === 'GRAY') {
          return '999'
        }
      }

      return '000'
    },

    gifLoaderImage() {
      return `/Plugins/Unity.Freestyle/Content/images/loader-rolling-${this.gifColor}.gif`
    },
  },
  props: {
    position: {
      type: String,
      default: 'inline',
      validator: (value) => {
        const positions = ['inline', 'fixed', 'absolute']
        return positions.includes(value)
      },
    },
    size: {
      type: String,
      default: null,
      validator: (value) => {
        const sizes = ['sm', 'md', 'lg']
        return sizes.includes(value)
      },
    },
    loaderColor: {
      type: String,
      default: '#fff',
    },
  },
}
</script>
<style lang="scss">
@import '../../../Content/scss/lib/functions';
.ax--loader {
  width: pxrem(32);
  height: pxrem(32);

  &--sm {
    width: pxrem(16);
    height: pxrem(16);
  }

  &--md {
    width: pxrem(32);
    height: pxrem(32);
  }

  &--lg {
    width: pxrem(65);
    height: pxrem(65);
  }

  &.inline {
    position: relative;

    width: 1em;
    height: 1em;
  }

  &.fixed,
  &.absolute {
    z-index: 1000;
    top: 50%;
    left: 50%;
    transform: translateY(-50%) translateX(-50%);
  }

  &.fixed {
    position: fixed;
  }

  &.absolute {
    position: absolute;
  }

  svg {
    width: 100%;
    height: 100%;

    path {
      fill: inherit;
    }
  }

  img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateY(-50%) translateX(-50%);

    width: 100%;
    height: 100%;
  }
}
</style>
